import { useEffect } from "react";
import { useAuthStore } from "../store";
import withRouter from "../hocs/withRouter";
import path from "../ultils/path";
import { phototime_logo } from "../assets";

const HomePage = ({ navigate }: any) => {
  const { token } = useAuthStore();

  useEffect(() => {
    if (!token) {
      navigate(path.SIGN_IN);
    } else {
      navigate(path.STATISTICAL_MANAGE);
    }
  }, [token]);

  return (
    <>
      <div className="w-[100%] h-screen flex flex-col justify-center items-center">
        <h3 className="text-photo-time-pink-light font-semibold lg:text-3xl md:text-2xl pb-4 text-xl">
          PHOTO TIME - MANAGE WEBSITE
        </h3>
        <img src={phototime_logo} alt="logo" className="w-[60%]"></img>
      </div>
    </>
  );
};

export default withRouter(HomePage);
